import { Society } from 'types';
import { SocietyCorporateId } from 'types/Society';
import { partnerDetailsByCorporateId } from '../constants/partnerDetailsByCorporateId';

const globalCorporateId = process.env.REACT_APP_UI_CORPORATE_ID;

export const getPartnerDetailsConfigByCorporateId = (society?: Society) => {
  const corporateId = (globalCorporateId ||
    society?.corporateId ||
    SocietyCorporateId.DEFAULT) as SocietyCorporateId;

  return partnerDetailsByCorporateId[corporateId];
};
